// extracted by mini-css-extract-plugin
module.exports = {"backdrop":"Modal_backdrop__3R4ST","container":"Modal_container__39_NS","header":"Modal_header__3txAo","title":"Modal_title__2VeSv","wrapper":"Modal_wrapper__3H1kL"};